export enum SignupAction { POSITIVE, NEGETIVE }



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/shared/signup/signup.enum.ts